/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExpenseCreateBatchRequest
 */
export interface ExpenseCreateBatchRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ExpenseCreateBatchRequest
     */
    expenseIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ExpenseCreateBatchRequest
     */
    comment?: string;
}

/**
 * Check if a given object implements the ExpenseCreateBatchRequest interface.
 */
export function instanceOfExpenseCreateBatchRequest(value: object): value is ExpenseCreateBatchRequest {
    if (!('expenseIds' in value) || value['expenseIds'] === undefined) return false;
    return true;
}

export function ExpenseCreateBatchRequestFromJSON(json: any): ExpenseCreateBatchRequest {
    return ExpenseCreateBatchRequestFromJSONTyped(json, false);
}

export function ExpenseCreateBatchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpenseCreateBatchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'expenseIds': json['expenseIds'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function ExpenseCreateBatchRequestToJSON(value?: ExpenseCreateBatchRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'expenseIds': value['expenseIds'],
        'comment': value['comment'],
    };
}

